const LOGO_URL = "/brand/qick-logo.png";
const COMPANY_LEGAL = {
    name: "QICK!",
    kvk: "88209288",
    email: "contact@qickapp.com",
};

const NAV_LINKS = [
    { label: "Hoe werkt het", href: "#hoe-werkt-het" },
    { label: "Branches", href: "#branches" },
    { label: "Work & Connect", href: "#qick-work" },
    { label: "Prijzen", href: "#pricing" },
    { label: "Contact", href: "#contact" },
];

const LEGAL_LINKS = [
    {
        label: "Algemene voorwaarden",
        href: "/legal/QICK_Algemene_Voorwaarden_v1.0_volledig.pdf",
    },
    {
        label: "Privacyverklaring",
        href: "/legal/QICK_Privacyverklaring_v1.0_volledig.pdf",
    },
    {
        label: "Verwerkersovereenkomst",
        href: "/legal/QICK_Verwerkersovereenkomst_v1.0_volledig.pdf",
    },
];

const handleClick = (e, href) => {
    if (!href) return;
    e.preventDefault();
    const el = document.querySelector(href);
    const reduceMotion = window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches;
    if (el) el.scrollIntoView({ behavior: reduceMotion ? "auto" : "smooth", block: "start" });
};

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="relative bg-[#0B1528] text-slate-300"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20">
                <div className="grid grid-cols-1 gap-10 md:grid-cols-[1.4fr_1fr_1fr_1.2fr] lg:gap-14">
                    <div>
                        <a
                            href="#top"
                            onClick={(e) => handleClick(e, "#top")}
                            data-testid="footer-logo"
                            className="inline-flex items-center gap-2.5 rounded-xl transition-all hover:-translate-y-0.5"
                        >
                            <span className="inline-flex h-10 w-10 items-center justify-center overflow-hidden rounded-xl bg-[#0251B7] ring-1 ring-white/10">
                                <img
                                    src={LOGO_URL}
                                    alt="QICK!"
                                    className="h-11 w-11 rounded-xl object-cover"
                                />
                            </span>
                            <span className="text-white font-semibold text-lg">
                                QICK!
                            </span>
                        </a>
                        <p className="mt-4 text-sm text-slate-400 leading-relaxed max-w-sm">
                            Alles in één voor klanten, klussen, offertes, planning, personeel,
                            uren en facturen.
                        </p>
                        <div className="mt-5 space-y-1 text-xs leading-relaxed text-slate-500">
                            <p>{COMPANY_LEGAL.name}</p>
                            <p>KvK: {COMPANY_LEGAL.kvk}</p>
                        </div>
                    </div>

                    <div>
                        <div className="text-sm font-medium text-white uppercase tracking-wider">
                            Navigatie
                        </div>
                        <ul className="mt-4 grid grid-cols-1 gap-2.5">
                            {NAV_LINKS.map((link) => (
                                <li key={link.href}>
                                    <a
                                        href={link.href}
                                        onClick={(e) => handleClick(e, link.href)}
                                        data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                                        className="inline-flex min-h-10 items-center text-sm font-normal text-slate-300 transition-all hover:translate-x-1 hover:text-white"
                                    >
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <div className="text-sm font-medium text-white uppercase tracking-wider">
                            Juridisch
                        </div>
                        <p className="mt-4 text-xs text-slate-500">
                            Juridische documenten en AVG-documentatie · versie 1.0
                        </p>
                        <ul className="mt-4 grid grid-cols-1 gap-2.5">
                            {LEGAL_LINKS.map((link) => (
                                <li key={link.href}>
                                    <a
                                        href={link.href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        data-testid={`footer-link-${link.label.toLowerCase().replace(/\s+/g, "-")}`}
                                        className="inline-flex min-h-10 items-center text-sm font-normal text-slate-300 transition-all hover:translate-x-1 hover:text-white"
                                    >
                                        {link.label}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div>
                        <div className="text-sm font-medium text-white uppercase tracking-wider">
                            Contact
                        </div>
                        <a
                            href="#contact"
                            onClick={(e) => handleClick(e, "#contact")}
                            data-testid="footer-contact-email"
                            className="mt-4 inline-flex min-h-10 items-center text-sm font-normal text-slate-200 transition-colors hover:text-white"
                        >
                            Contactformulier
                        </a>
                        <a
                            href={`mailto:${COMPANY_LEGAL.email}`}
                            className="block text-sm font-normal text-slate-200 transition-colors hover:text-white"
                        >
                            {COMPANY_LEGAL.email}
                        </a>
                        <p className="mt-3 text-sm text-slate-500 leading-relaxed">
                            Vragen over QICK!, QICK Work, QICK Connect of zakelijke toegang zijn welkom.
                        </p>
                        <p className="mt-3 text-xs text-slate-500 leading-relaxed">
                            Nederlandse software. Bedrijven betalen QICK! als SaaS-platform; QICK! neemt geen percentage van het uurtarief.
                        </p>
                    </div>
                </div>

                <div className="mt-12 pt-6 border-t border-white/10 flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
                    <p className="text-xs text-slate-500">
                        © 2026 QICK!. Alle rechten voorbehouden.
                    </p>
                    <p className="text-xs text-slate-500">
                        Beschikbaar in NL · EN · FR · PL · DE · ES
                    </p>
                    <p className="text-xs text-slate-500">
                        qickapp.com voor marketing. app.qickapp.com voor de software.
                    </p>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
